import { render, staticRenderFns } from "./lessonSys.vue?vue&type=template&id=34b22d22&scoped=true"
import script from "./lessonSys.vue?vue&type=script&lang=js"
export * from "./lessonSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b22d22",
  null
  
)

export default component.exports